import { Grid } from '@material-ui/core';
import { Class } from '@material-ui/icons';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import HomeIcon from '@material-ui/icons/HomeRounded';
import {
  getInfosDashboard,
  getInfosSchool,
  getNotifications,
  getTrainingType,
} from '@webapps/business';
import {
  Modal,
  useAuth,
  useMutation,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import IncompleteVitrine from 'pages/Business/Dashboard/Components/IncompleteVitrine';
import { useEffect, useState } from 'react';

import Presentation from '../../Business/Dashboard/Components/Presentation';
import Contract from '../ClassesPage/ClassesDetail/Components/Contract';
import AffiliationChart from './Components/Charts/AffiliationChart';
import ApplicationChart from './Components/Charts/ApplicationChart';
import ClassesChart from './Components/Charts/ClassesChart';
import ContractChart from './Components/Charts/ContractChart';
import DistributedColumnChart from './Components/Charts/DistributedColumnChart';
import PartnerChart from './Components/Charts/PartnerChart';
import TrainingChart from './Components/Charts/TrainingChart';
import Info from './Components/Info';
import Notifications from './Components/SchoolNotifications';
import Synthesis from './Components/Synthesis';
import theme from './theme';

const { NX_REST_API } = process.env;

const {
  colors: { background },
} = theme;

const DashboardSchool = () => {
  const { classes, css, cx } = useStyles(styles);
  const [incompleteVitrine, setIncompleteVitrine] = useState(false);

  const { idUser, profile } = useAuth();

  const [page, setPage] = useState(0);

  const { data: trainingTypes = {} } = useQuery(getTrainingType, {
    key: 'trainingType',
  });

  const { data: allInfos = {} } = useQuery(getInfosSchool, {
    key: 'schoolInfos',
    variables: { id: idUser },
  });

  const {
    data: dashboardInfo = {},
    refetch,
    isLoading: isLoadingDashboard,
    isFetching: isFetchingDashboard,
  } = useQuery(getInfosDashboard, {
    key: 'infoDashboardSchool',
    variables: { id: idUser },
  });

  const {
    data: {
      content: notifs = [],
      totalElements,
      isLoading: notifsLoading,
      isFetching: notifsFetching,
    } = {},
    refetch: refetchNotifs,
  } = useQuery(getNotifications, {
    key: ['notifsStudent', page + idUser],
    variables: {
      id: idUser,
      page: 0,
      size: 3,
      status: 'all',
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  useEffect(() => {
    if (
      allInfos?.address?.label &&
      allInfos?.website &&
      allInfos?.phone &&
      allInfos?.sector?.label &&
      allInfos?.size?.min &&
      allInfos?.size?.max &&
      allInfos?.headOffice?.city &&
      allInfos?.headOffice?.cityCode &&
      allInfos?.foundationDate
    )
      setIncompleteVitrine(false);
    else setIncompleteVitrine(true);
  }, []);

  return (
    <div className={classes.container}>
      {profile === 'SCHOOL' &&
        idUser === dashboardInfo.profile?.id &&
        dashboardInfo.profile.completeRate !== 100 && (
          <div style={{ width: '100%' }}>
            <IncompleteVitrine
              open={incompleteVitrine}
              setOpen={setIncompleteVitrine}
            />
          </div>
        )}
      <div
        className={css({
          display: 'flex',
          columnGap: 30,
          width: '100%',
          rowGap: 20,
          flexDirection: 'row',
        })}
      >
        {/* LEFT CARD
          --------------------------------------------------------------*/}
        <Grid
          container
          className={css({
            columnGap: '30px',
            '@media screen and (max-width: 768px)': {
              rowGap: 20,
            },
          })}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={5}
            lg={3}
            xl={3}
            className={cx(
              classes.grid,
              css({
                height: 'fit-content',
              })
            )}
          >
            <Synthesis
              coverImage={dashboardInfo?.profile?.coverImageUrl}
              profileImage={dashboardInfo?.profile?.profileImageUrl}
              name={allInfos?.name}
              city={allInfos?.address?.city}
              cp={allInfos?.address?.cityCode}
              verified={dashboardInfo?.profile?.verified}
              sector={allInfos?.sector?.label}
              presentation={dashboardInfo?.profile?.slogan}
              location={allInfos?.address?.label}
            />
            {/* <Presentation
                email={allInfos?.email}
                foundationDate={allInfos?.foundationDate}
                headOffice={`${allInfos?.headOffice?.city} ${allInfos?.headOffice?.cityCode}`}
                location={allInfos?.address?.label}
                phone={allInfos?.phone}
                presentation={dashboardInfo?.profile?.presentation}
                publicPrivee={allInfos?.public}
                sector={allInfos?.sector?.label}
                sizeMax={allInfos?.size?.max}
                sizeMin={allInfos?.size?.min}
                specialization={allInfos?.specialization?.label}
                website={allInfos?.website}
                publicPrive={allInfos?.public}
              /> */}

            {/* MIDDLE CARD (NOTIFICATIONS)
          --------------------------------------------------------------*/}
          </Grid>
          <Grid
            item
            xs={12}
            sm
            className={cx(
              classes.grid,
              css({
                height:
                  notifs?.length > 0
                    ? 'fit-content'
                    : 'calc(100vh - 75px - 53px)',
                '@media screen and (max-width: 768px)': {
                  height: 'fit-content',
                },
              })
            )}
          >
            <Notifications
              notifs={notifs}
              totalElements={totalElements}
              notifsFetching={notifsFetching}
              notifsLoading={notifsLoading}
            />
          </Grid>

          {/* RIGHT CARD (STATS)
          --------------------------------------------------------------*/}
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            className={classes.mainstatscontainer}
          >
            <Grid
              container
              className={classes.grid}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
              }}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des visibilités
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  borderRadius: 10,
                }}
              >
                <DistributedColumnChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={classes.grid}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                marginTop: 20,
              }}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des formations
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{

                  borderRadius: 10,
                }}
              >
                <TrainingChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={classes.grid}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                marginTop: 20,
              }}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des candidatures
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  borderRadius: 10,
                }}
              >
                <ApplicationChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={classes.grid}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                marginTop: 20,
              }}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des affiliations
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  borderRadius: 10,
                }}
              >
                <AffiliationChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={classes.grid}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                marginTop: 20,
              }}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des contrats
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  borderRadius: 10,
                }}
              >
                <ContractChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={classes.grid}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                marginTop: 20,
              }}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des partenaires
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  borderRadius: 10,
                }}
              >
                <PartnerChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className={css({
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                background,
                borderRadius: 10,
                height: 'fit-content',
                marginTop: 20,
                marginBottom: 25,
                '@media screen and (max-width: 768px)': {
                  marginBottom: 0,
                },
              })}
              direction="column"
            >
              <Grid item xs={12}>
                <div
                  className={css({
                    color: '#152652',
                    fontWeight: 600,
                    fontFamily: 'Montserrat',
                    marginBottom: 20,
                    '@media only screen and (max-width:1920px)': {
                      fontSize: '15.0px',
                    },
                    '@media only screen and (max-width:1600px)': {
                      fontSize: '15px',
                    },
                  })}
                >
                  Statistiques des classes
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  borderRadius: 10,
                }}
              >
                <ClassesChart
                  dashboardInfo={dashboardInfo}
                  isFetchingDashboard={isFetchingDashboard}
                  isLoadingDashboard={isLoadingDashboard}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

/* STYLES
  --------------------------------------------------------------*/
const styles = ({ fontSizes, spacing }) => ({
  container: {
    // height: '100%',
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    fontSize: '13.5000px',
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '100%',
    '@media only screen and (max-width:768px)': {
      padding: '20px',
    },
  },
  maingridcontainer: {
    overflow: 'auto',
  },
  dashInfosContainer: {
    marginTop: spacing(4),
    '@media only screen and (min-width:640px)': {
      marginTop: spacing(0),
    },
    '@media only screen and (max-width:1280px)': {
      marginTop: spacing(2.5),
      marginBottom: spacing(4),
    },
  },
  grid: {
    // NEED CONFIRMATION
    background,
    borderRadius: 10,
    height: 'fit-content',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  paper: {
    padding: spacing(2),
  },
  dashInfosItem: {
    paddingBottom: spacing(5),
    paddingLeft: spacing(5),
    '@media only screen and (max-width:1200px)': {
      paddingBottom: spacing(2.5),
      paddingLeft: spacing(2),
    },
    '@media only screen and (max-width:640px)': {
      paddingLeft: spacing(0),
    },
  },
  mainstatscontainer: {
    margin: '0',
    height: 'calc(100vh - 75px - 25px)',
    '@media screen and (max-width: 768px)': {
      height: 'fit-content',
      overflow: 'visible',
    },
    display: 'flex',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '@media only screen and (max-width:1280px)': {
      overflow: 'visible',
      margin: '0',
    },
  },
  statscards: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    border: '1px solid #E0E0E0',
    borderRadius: '10px',
  },
});

export default DashboardSchool;